// Port dla konceptu "żywy" (t_3d96c476) z store-integration/preview/assets/pdp/pdp-gallery-sync.js
// Product imagery: loading, bounded preload and matching embroidery on every gallery view.
(() => {
  const root = document.querySelector('[data-product-page]');
  const product = window.ALTIVEST_PRODUCT_DATA?.products.find(p => p.model === ((window.AV_MODEL||new URLSearchParams(location.search).get('model')) || 'TSRA190'));
  if (!root || !product) return;
  const loader = document.querySelector('[data-pdp-loading]');
  const fail = [];
  const loaded = img => new Promise(resolve => {
    if (!img.getAttribute('src')) return resolve();
    img.loading = 'eager'; img.decoding = 'async';
    const done = () => { if (!img.naturalWidth) fail.push(img.getAttribute('src')); resolve(); };
    if (img.complete) done(); else { img.addEventListener('load', done, {once:true}); img.addEventListener('error', done, {once:true}); }
  });
  Promise.all([...document.images].map(loaded)).then(() => {
    root.dataset.imagesReady = fail.length ? 'error' : 'true';
    if (loader) { if (fail.length) { loader.textContent = 'Nie udało się wczytać części zdjęć. Odśwież stronę.'; const close = document.createElement('button'); close.textContent = 'Kontynuuj'; close.onclick = () => loader.remove(); loader.append(close); } else loader.remove(); }
    sync();
  });
  const frames = [...root.querySelectorAll('.pdp-ed-frame')];
  // t_3fa4fc96: widok (przód/tył/model) każdego zdjęcia z danych, nie z nazwy pliku. Realne zdjęcia drive25 tyłu nie mają "-back" w nazwie.
  const viewOf = new Map();
  (product.gallery || []).forEach(g => { if (g && g.image && g.view) viewOf.set(g.image, g.view); });
  Object.values(window.ALTIVEST_COLOR_PHOTOS?.products?.[product.model]?.photos || {}).forEach(set => ['front', 'back', 'model'].forEach(k => { if (set && set[k] && !viewOf.has(set[k])) viewOf.set(set[k], k); }));
  if (product.backImage) viewOf.set(product.backImage, 'back');
  const baseName = s => String(s || '').split('?')[0].split('/').pop().replace(/^pdp-img-/, '');
  const srcBase = new Set(); (product.gallery || []).forEach(g => { if (g && g.image && g.view === 'source') srcBase.add(baseName(g.image)); });
  const pathOf = src => { try { return new URL(src, location.href).pathname; } catch (e) { return src || ''; } };
  const photoView = photo => {
    const src = pathOf(photo.getAttribute('src'));
    if (srcBase.has(baseName(src))) return 'source';
    if (viewOf.has(src)) return viewOf.get(src);
    const k = photo.dataset.colorBase; if (k) return k;
    return /-model\./.test(src) ? 'model' : /-back\./.test(src) ? 'back' : 'front';
  };
  function sync() {
    const source = root.querySelector('[data-layer]');
    if (!source) return;
    // Haft tylko na ujęciach zgodnych z wybranym miejscem: Pierś/Przód = zdjęcia przodu, Plecy = zdjęcia tyłu.
    const wanted = root.dataset.activePlacement === 'back' ? 'back' : 'front';
    frames.forEach(frame => {
      frame.querySelector(':scope > .pdp-gallery-layer')?.remove();
      if (source.hidden || frame.closest('figure').hidden) return;
      const photo = frame.querySelector('.pdp-ed-photo');
      if (!photo || photoView(photo) !== wanted) return;
      const layer = source.cloneNode(true); layer.removeAttribute('data-layer'); layer.classList.add('pdp-gallery-layer');
      layer.querySelectorAll('[data-text-preview],[data-motif-preview]').forEach(n => { n.removeAttribute('data-text-preview'); n.removeAttribute('data-motif-preview'); });
      const box = (window.ALTIVEST_PREVIEW_BOXES || {})[photo.getAttribute('src')] || (wanted === 'back' ? product.backPreviewBox : product.previewBox);
      if (!box) return;
      const rect = photo.getBoundingClientRect(); const iw = photo.naturalWidth || product.imageWidth; const ih = photo.naturalHeight || product.imageHeight;
      const scale = Math.min(rect.width/iw, rect.height/ih); const w = iw*scale; const h = ih*scale;
      const [x,y,bw,bh] = box;
      Object.assign(layer.style,{left:((rect.width-w)/2+w*x/100)+'px',top:((rect.height-h)/2+h*y/100)+'px',width:w*bw/100+'px',height:h*bh/100+'px'});
      frame.append(layer);
    });
  }
  let raf = 0;
  const queue = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); };
  ['click','input','change'].forEach(event => root.addEventListener(event,queue));
  root.addEventListener('load',queue,true); addEventListener('resize',queue);
  const layer = root.querySelector('[data-layer]');
  if (layer) new MutationObserver(queue).observe(layer,{attributes:true,childList:true,subtree:true,characterData:true});
  const photos = window.ALTIVEST_COLOR_PHOTOS?.products[product.model]?.photos || {};
  // Preload a hovered/focused color only, rather than fetching every variant at startup.
  const preloaded = new Set();
  const preload = event => {
    const button = event.target.closest('[data-color-sample]'); if (!button) return;
    Object.values(photos[button.dataset.colorSample] || {}).forEach(src => { if (!preloaded.has(src)) { preloaded.add(src); const img = new Image(); img.src = src; } });
  };
  root.addEventListener('pointerover',preload); root.addEventListener('focusin',preload);
  const purchase = root.querySelector('.pdp-wz-summary');
  if (purchase) {
    const list = document.createElement('ul'); list.className = 'pdp-usp';
    [].forEach(text => { const li=document.createElement('li'); li.textContent=text;list.append(li); });
    purchase.after(list);
  }
  sync();
})();
